import { isEmpty } from "lodash";
import { LOCAL_USER_MANAGEMENT_SYSTEM_URL } from "./const";

export function getUmsDashboardUrl() {
  const REACT_ENV = process.env.REACT_APP_HOST_ENV;
  const UMS_URL = !!process.env.REACT_APP_UMS_URL && process.env.REACT_APP_UMS_URL !== "" ? process.env.REACT_APP_UMS_URL : LOCAL_USER_MANAGEMENT_SYSTEM_URL;
  if (!isEmpty(REACT_ENV)) {
    return UMS_URL;
  } else {
    return LOCAL_USER_MANAGEMENT_SYSTEM_URL;
  }
}

export const getUmsDashboardValue = () => {
  return getUmsDashboardUrl();
};
